module.exports = __webpack_public_path__ + "static/img/sg_logo_navigation_bar.2e4dc2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sg/sg_logo_navigation_bar.png
// module id = 9NHS
// module chunks = 28